if ( !customElements.get( 'custom-variation-form' ) ) {
    class CustomVariationForm extends HTMLElement {
        constructor( ) {
            super( );
        }

        connectedCallback( ) {
            this.init( );
        }

        init( ) {
            const fm = this.querySelector( "#fabric-manufacturer" );
            if ( fm ) {
                fm.addEventListener( "input" , this.handleRemoveHighlight );
            }

            const fn = this.querySelector( "#fabric-name" );
            if ( fn ) {
                fn.addEventListener( "input" , this.handleRemoveHighlight );
            }

            const cn = this.querySelector( "#color-name" );
            if ( cn ) {
                cn.addEventListener( "input" , this.handleRemoveHighlight );
            }

            const cnu = this.querySelector( "#color-number" );
            if ( cnu ) {
                cnu.addEventListener( "input" , this.handleRemoveHighlight );
            }

            const tfm = this.querySelector( "#trim-fabric-manufacturer" );
            if ( tfm ) {
                tfm.addEventListener( "input" , this.handleRemoveHighlight );
            }

            const tfn = this.querySelector( "#trim-fabric-name" );
            if ( tfn ) {
                tfn.addEventListener( "input" , this.handleRemoveHighlight );
            }

            const radios = this.querySelectorAll( 'input[type="radio"]' );
            for ( let i = 0; i < radios.length; i++ ) {
                const radio = radios[ i ];
                radio.addEventListener( "change" , this.handleRadioChange );
            }

            const inputs = this.querySelectorAll( ".custom-variation-form input, .custom-variation-form select, .custom-variation-form textarea" );
            for ( let i = 0; i < inputs.length; i++ ) {
                const input = inputs[ i ];
                input.addEventListener("input", this.updateATCButtonState.bind( this ) );
            }

            this.domContentInit();
        }

        domContentInit() {
            document.addEventListener( "DOMContentLoaded" , () => {
                const fabricPhotoUploader = this.querySelector( ".fabric-photo" );
                const trimPhotoUploader = this.querySelector( ".trim-photo" );
                const colorPhotoUploader = this.querySelector( ".color-photo" );

                const fabricPhotoInput = this.querySelector( 'input[name="properties[Fabric Photo]"]' );
                const trimPhotoInput = this.querySelector( 'input[name="properties[Trim Fabric Photo]"]' );
                const colorPhotoInput = this.querySelector( 'input[name="properties[Color Photo]"]' );

                this.attachFileUploadSuccessEvent( colorPhotoUploader , colorPhotoInput );
                this.attachFileUploadSuccessEvent( trimPhotoUploader , trimPhotoInput );
                this.attachFileUploadSuccessEvent( fabricPhotoUploader , fabricPhotoInput );
            });
        }

        handleRemoveHighlight( e ) {
            const input = this;
            input.classList.remove( "highlight" );

            return;
        }

        handleRadioChange( e ) {
            const radio = this;
            const radioGroupContainer = radio.closest( ".radio-container" );
            if ( radioGroupContainer ) {
                radioGroupContainer.classList.remove( "highlight" );
            }

            return;
        }

        attachFileUploadSuccessEvent( uploader , input ) {
            if ( !uploader ) {
                return;
            }

            if ( !input ) {
                return;
            }

            uploader.addEventListener('file-upload-success', function( e ) {
                input.value = e.detail.cdnUrl;
            });

            return;
        }

        areRequiredFieldsFilled( section ) {
            const requiredFields = section.querySelectorAll( "[required]" );
            for ( let field of requiredFields ) {
                if ( field.type === "text" && !field.value ) {
                    return false;
                }

                if ( field.type === "radio" && !section.querySelector( `input[name="${field.name}"]:checked` ) ) {
                    return false;
                }
            }

            return true;
        }

        updateATCButtonState( e ) {
            const form = this.querySelector( ".custom-variation-form" );
            if ( !form ) {
                return;
            }

            const productForm = form.closest( ".product-form" );
            if ( !productForm ) {
                return;
            }

            const fabricContainer = form.querySelector( ".fabric-container" );
            const colorContainer = form.querySelector( ".color-container" );
            const trimContainer = form.querySelector( ".trim-fabric-container" );

            if ( !fabricContainer || !colorContainer || !trimContainer ) {
                return;
            }

            let allFieldsFilled = true;
            if ( !fabricContainer.classList.contains( "hide" ) && !this.areRequiredFieldsFilled( fabricContainer ) ) {
                allFieldsFilled = false
            }

            if ( !colorContainer.classList.contains( "hide" ) && !this.areRequiredFieldsFilled( colorContainer ) ) {
                allFieldsFilled = false
            }

            if ( !trimContainer.classList.contains( "hide" ) && !this.areRequiredFieldsFilled( trimContainer ) ) {
                allFieldsFilled = false
            }

            const atcButton = productForm.querySelector( ".custom-atc-btn" );
            this.toggleATCButton( atcButton , allFieldsFilled );
        }

        toggleATCButton( button , enabled ) {
            if ( !button ) {
                return;
            }

            const shouldEnabled = ( enabled === true );
            if ( shouldEnabled ) {
                button.removeAttribute( "disabled" );
                button.classList.remove( "com-form-disabled" );
            } else {
                button.setAttribute( "disabled" , "true" );
                button.classList.add( "com-form-disabled" );
            }
        }
    }

    customElements.define( 'custom-variation-form', CustomVariationForm );
}